module.exports = {
      id: "dh-symbol-usage",
      viewBox: "0 0 344.84 299.91",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#dh-symbol",
      toString: function () {
        return this.url;
      }
    }